import styles from './spoilerFog.module.scss';
import React, { use, useId } from 'react';
import { Tooltip } from 'react-tooltip';
import { revealAllSpoilers, revealSpoiler, useSpoilerFogged } from 'lib/spoilers';
import { ModalPortalContext } from 'components/ui/Modal/Modal';

const REVEAL_ALL_HELP = 'Click to show every spoiler until you close this tab';
const TOOLTIP_Z_INDEX = 10000000000;

interface Props {
  name: string;
  spoiler: boolean;
  /* Off in hover previews, which reveal spoilers as a whole. */
  interactive?: boolean;
  blurContent?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const SpoilerFog: React.FC<Props> = ({ name, spoiler, interactive = true, blurContent, className, children }) => {
  const tooltipId = useId();
  const fogged = useSpoilerFogged({ name, spoiler });
  const modal = use(ModalPortalContext);
  const reveal = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    revealSpoiler(name);
  };
  const revealAll = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    revealAllSpoilers();
  };

  return (
    <div
      className={`${styles.spoilerFog} ${fogged ? styles.fogged : ''} ${blurContent ? styles.blurContent : ''} ${className ?? ''}`}
    >
      {children}
      {spoiler && (
        <div className={`${styles.fog} ${fogged ? '' : styles.dissolved}`} aria-hidden={!interactive || undefined}>
          {interactive ? (
            <>
              <button type="button" className={styles.veil} aria-label="Reveal this spoiler card" onClick={reveal} />
              <button
                type="button"
                className={styles.label}
                onClick={revealAll}
                data-tooltip-id={tooltipId}
                data-tooltip-content={REVEAL_ALL_HELP}
              >
                Spoiler
              </button>
              {fogged && (
                // out of the card's flip transform, and into the replacements modal when shown there
                <Tooltip
                  id={tooltipId}
                  positionStrategy="fixed"
                  portalRoot={modal ?? (typeof document === 'undefined' ? undefined : document.body)}
                  style={{ zIndex: TOOLTIP_Z_INDEX }}
                />
              )}
            </>
          ) : (
            <span className={styles.label}>Spoiler</span>
          )}
        </div>
      )}
    </div>
  );
};

export default SpoilerFog;
